import { get, post, put } from "./helpers";
import { limitNumberOfCalls } from "../lib/utils";

export const fetchAppointments = async (query) => {
  console.log(query);
  const url = `/api/agency/appt?start=03-20&end=04-20`;
  const result = await get(url);
  return result.data;
};

export const fetchAppointment = async (apptNumber, authToken) => {
  const url = `/api/agency/appt/${apptNumber}`;
  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : undefined;
  const result = await get(url, headers);
  return result.data;
};

export const rateAppointment = async (apptNumber, ratings, authToken) => {
  console.log("In rate Appointment" + apptNumber + JSON.stringify(ratings));
  const url = `/api/agency/appt/${apptNumber}/ratings`;
  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : undefined;
  const result = await post(url, ratings, headers);
  console.log(JSON.stringify(result));
  return result;
};

// make sure to make only 1 call to start/finish activity for each window open.
export const startInterpreterActivity = limitNumberOfCalls(
  1,
  async (appointmentId, activityType) => {
    const url = `/api/agency/appt/${appointmentId}/activities`;
    const result = await post(url, { activityType });
    return result.data;
  },
  () => Promise.reject(new Error("Can't start activity twice"))
);

// make sure to make only 1 call to start/finish activity for each window open.
export const completeInterpreterActivity = limitNumberOfCalls(
  1,
  async (appointmentId, activityId) => {
    const url = `/api/agency/appt/${appointmentId}/activities/${activityId}/finish`;
    const result = await put(url);
    return result.data;
  },
  () => Promise.reject(new Error("Can't complete activity twice"))
);

// make sure to make only 1 call to start/finish appointment for each window open.
export const completeAppointment = limitNumberOfCalls(
  1,
  async (appointmentId) => {
    const url = `/api/agency/appt/${appointmentId}/finish`;
    const result = await put(url);
    return result.data;
  }
);
